import * as Sentry from '@sentry/react';
import { call, put, takeEvery } from "redux-saga/effects";

import {
    FETCH_INTEGRATION_REQUESTED,
    CREATE_INTEGRATION_REQUESTED
} from "../actionTypes"

import {
    fetchIntegrationService,
    createIntegrationService
} from "../../services/integration"

import {
    fetchIntegrationSuccess,
    fetchIntegrationFailure,
    createIntegrationSuccess,
    createIntegrationFailure,
} from "../actions";
import { useGlobalStore } from "../../zustand-store/useGlobalStore";

function* fetchIntegrationSaga(action) {
    try {
        const integration = yield call(fetchIntegrationService, action.payload);
        yield put(fetchIntegrationSuccess(integration))
    } catch (e) {
        Sentry.captureException(e);
        yield put(fetchIntegrationFailure(e));
    }
}

function* createIntegrationSaga(action) {
    try {
        const integration = yield call(createIntegrationService, action.payload);
        if(integration.success){
            yield put(createIntegrationSuccess(integration.data))
            // ✨ Migrated to Zustand
            const { setSideBarPageType } = useGlobalStore.getState();
            setSideBarPageType("MENU");
        }
    } catch (e) {
        Sentry.captureException(e);
        yield put(createIntegrationFailure(e));
    }
}

// ✨ fetchIntegrationProfilesSaga removed - migrated to React Query (useSavedProfiles hook)
// ✨ deleteAudioProfileSaga removed - migrated to React Query (useDeleteProfile hook)

function* integrationSaga() {
    yield takeEvery(FETCH_INTEGRATION_REQUESTED, fetchIntegrationSaga);
    yield takeEvery(CREATE_INTEGRATION_REQUESTED, createIntegrationSaga);
    // ✨ Profile-related sagas removed - now handled by React Query hooks
}

export default integrationSaga;
